import { render, staticRenderFns } from "./AdicionarImagem.vue?vue&type=template&id=ba7a70ea&"
import script from "./AdicionarImagem.vue?vue&type=script&lang=js&"
export * from "./AdicionarImagem.vue?vue&type=script&lang=js&"
import style0 from "./AdicionarImagem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports